<template>
  <div class="site__body">
    <div class="block-space block-space--layout--after-header"></div>
    <div class="block">
      <div class="container container--max--xl">
        <div class="row">
          <account-navigation
            active-page="account-addresses"
          ></account-navigation>
          <div class="col-12 col-lg-9 mt-4 mt-lg-0">
            <div class="addresses-list">

              <div class="col-12 col-md-12" v-if="$route.params.action == 'updated'">
                  <div class="alert alert-success mb-3">
                      <strong>{{ updated_message }}</strong> 
                  </div>
              </div>

              <!-- <a href="javascript:void(0);" class="addresses-list__item addresses-list__item--new">
                <div class="addresses-list__plus"></div>
                <div class="btn btn-secondary btn-sm">Add New</div>
              </a> -->
              <!-- <transition-group name="addresses"> -->
                <account-address-list-item 
                  v-for="(address, index) in addresslist" :key="address.id" :index="index" :addressdata="address" @remove-address="removeAddress"></account-address-list-item>
              <!-- </transition-group> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="block-space block-space--layout--before-footer"></div>
  </div>
  <base-dialog title="Confirm Delete" @close="cancelRemove" :open="selectedAddressIndex != null">
    <template #default>
      <p>Are you sure you want to remove this address?</p>
    </template>
    <template #actions>
      <button type="button" class="btn btn-sm btn-secondary" @click="cancelRemove">
        Cancel
      </button>
      <button type="button" class="btn btn-sm btn-primary" @click="confirmRemove">
        Ok
      </button>
    </template>
  </base-dialog>
</template>

<script>
import axiosvl from "../../../axios/axios-vl.js";

import AccountNavigation from "../accountnavigation/AccountNavigation";
import AccountAddressListItem from './AccountAddressListItem.vue';
import * as GCONST from '../../../constants.js';

export default {
  name: "AccountAddresses",
  components: {
    "account-navigation": AccountNavigation,
    "account-address-list-item": AccountAddressListItem
  },
  data() {
    return {
      addresslist: [],
      selectedAddressIndex: null,

      updated_message: GCONST.UPDATED_SHIP_ADDRESS,
    }
  },
  methods: {
    removeAddress(index) {
      this.selectedAddressIndex = index;
    },
    confirmRemove() {
      this.addresslist.splice(this.selectedAddressIndex, 1);
      this.selectedAddressIndex = null;
    },
    cancelRemove() {
      this.selectedAddressIndex = null;
    },

    getCustomerInfo() {
      this.isloading = true;

      axiosvl.post(this.$store.getters['api/get_customer_info_uri'], {
          "webroutine": {
              "context": {
                  "session-key-method": "hidden"
              },
              "fields": {
                  "EHCUST": {"value": this.$store.getters.customer},
              }
          }
      })
      .then((response) => {
          const fields = response.data.webroutine.fields;
          // console.log(fields);
          let messages = [];

          if (fields.RESULTCOD.value === 'OK') {
              
              this.addresslist.push(
                {
                  id: 1,
                  name: fields.ADNAME.value,
                  company: fields.CMNAME.value,
                  address1: fields.ADADD1.value,
                  address2: fields.ADADD2.value,
                  city: fields.ADCITY.value,
                  state: fields.ADSTTC.value,
                  zip: fields.ADZIPC.value,
                  phone: fields.ADPHON.value,
                  email: fields.ECEMAL.value,
                  type: 'billing',
                }
              );

              this.addresslist.push(
                {
                  id: 2,
                  name: fields.S2NAME.value,
                  company: fields.S2CNNM.value,
                  address1: fields.S2ADD1.value,
                  address2: fields.S2ADD2.value,
                  city: fields.S2CITY.value,
                  state: fields.S2STTC.value,
                  zip: fields.S2ZIPC.value,
                  phone: fields.S2PHON.value,
                  email: fields.ECEMAL.value,
                  type: 'shipping',
                }
              );

          } else {
              const wrmessages = response.data.webroutine.messages;

              for (var i = 0; i < wrmessages.length; i++) {
                  messages.push(wrmessages[i]);
              }

              // Return code is not "OK" but no messages appear, add a custom error message
              if (messages.length === 0) {
                  messages.push("Something went wrong. Please try again later.");
              }
          }

          this.isloading = false;
          // this.servermessages = messages;
      })
      .catch((error) => {
          this.isloading = false;
          console.log("error - " + error);
      });
    },
  },
  mounted() {
    this.$ga.page({
        page: this.$route.fullPath,
        title: this.$route.name,
    });
    this.addresslist = [];

    this.getCustomerInfo();
  }
};
</script>

<style scoped>
  .addresses-enter-from {
    opacity: 0;
    transform: translateX(-30px);
  }

  .addresses-enter-active {
    transition: all 1s ease-out;
  }

  .addresses-enter-to,
  .addresses-leave-from {
    opacity: 1;
    transform: translateX(0);
    transform: translateY(0);
  }

  .addresses-leave-active {
    transition: all .5s ease-in;
    position: absolute;
  }

  .addresses-leave-to {
    opacity: 0;
    transform: translateY(-50px);
  }

  .addresses-move {
    transition: transform 0.8s ease;
  }
</style>